var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk1712121250(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203.1 30",
    style: {
      enableBackground: "new 0 0 203.1 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 61.4741 117.5926)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 6.498 67.0528)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,30h-30.1V0h30.1V30z M116.3,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,25.9h-22.7V3.7h22.7V25.9z M120.3,24.8h20.4v-20h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.5087 15.9852)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.7998 9.6998)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,25.9H4V3.7h22.7V25.9z M5.1,24.8h20.4v-20H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.9,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 92.0727 168.5895)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 14.1757 95.8372)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.6,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1,30h-30.1V0h30.1V30z M174.1,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,25.9h-22.7V3.7h22.7V25.9z M178.1,24.8h20.4v-20h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 15.6949 41.2952)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -4.9894 23.9855)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30H28.7V0h30.1V30z M29.8,28.8h27.8V1.2H29.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,25.9H32.6V3.7h22.7V25.9z M33.8,24.8h20.4v-20H33.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 31.0279 66.8498)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.1413 38.4123)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,30H57.6V0h30.1V30z M58.8,28.8h27.8V1.2H58.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,25.9H61.6V3.7h22.7V25.9z M62.8,24.8h20.4v-20H62.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 46.2142 92.1598)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.9,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.6691 52.698)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,30H86.3V0h30.1V30z M87.5,28.8h27.8V1.2H87.5V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,25.9H90.3V3.7H113V25.9z M91.4,24.8h20.4v-20H91.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: -6.7,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 76.7394 143.0344)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 10.3276 81.4104)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,30H144V0h30.1V30z M145.1,28.8H173V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,25.9h-22.7V3.7h22.7V25.9z M149.1,24.8h20.4v-20h-20.4V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk1712121250);
export default __webpack_public_path__ + "static/media/AK1_7_1212125_0.387409024676c40bdfa7192ea7dc7037.svg";
export { ForwardRef as ReactComponent };